module.exports = __webpack_public_path__ + "static/media/search.9b51ec00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Svg/search.svg
// module id = 521
// module chunks = 0